
    import * as React from 'react';

    const Deposit16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M8 15A7 7 0 118 1a7 7 0 010 14zm0-.75a6.25 6.25 0 100-12.5 6.25 6.25 0 000 12.5zm2.252-5.658c.296.328.444.772.444 1.332s-.218 1.028-.654 1.404c-.436.376-.994.596-1.674.66v1.2h-.732v-1.212c-.664-.08-1.226-.318-1.686-.714-.46-.396-.71-.918-.75-1.566h.888c.016.36.178.682.486.966.308.284.662.466 1.062.546V8.304l-.348-.096c-1.184-.344-1.776-1.044-1.776-2.1 0-.536.204-.996.612-1.38.408-.384.912-.608 1.512-.672V2.844h.732v1.212c.568.08 1.066.306 1.494.678.428.372.666.862.714 1.47h-.888c-.048-.384-.192-.694-.432-.93a1.73 1.73 0 00-.888-.462v2.856l.552.156c.592.176 1.036.432 1.332.768zM7.564 7.428l.072.024V4.8c-.408.048-.726.188-.954.42-.228.232-.342.528-.342.888 0 .336.096.608.288.816.192.208.504.376.936.504zm.804 3.804c.424-.048.78-.19 1.068-.426.288-.236.432-.53.432-.882 0-.344-.094-.618-.282-.822-.188-.204-.502-.37-.942-.498l-.276-.084v2.712z" /></svg>
        </div>
      );
    };

    Deposit16.displayName = 'Deposit16';

    export default Deposit16;
  